import * as React from 'react';
import { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AppShell from '../../chrome/AppShell';
import useUserOrg from '../../../Authentication/components/hooks/useUserOrg';
import { useDeviceGroup } from '../../../DeviceManagement/components/hooks/useDeviceGroup';
import { Crumb, Field, SectionCard, TextInput } from '../../components/forms';
import { PageHeadActions } from '../../components/nav';
import { canGoBack } from './shared';
import './devices.css';

export default function DeviceGroupCreateV3() {
    const navigate = useNavigate();
    const { orgId } = useUserOrg();
    const { createDeviceGroup } = useDeviceGroup(orgId);
    const [name, setName] = useState('');
    const [nameError, setNameError] = useState('');
    const [saveError, setSaveError] = useState('');
    const [saving, setSaving] = useState(false);
    const busy = useRef(false);

    const leave = () =>
        canGoBack() ? navigate(-1) : navigate('/device-management#groups');

    const submit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (busy.current || !orgId) return;
        const trimmed = name.trim();
        if (!trimmed) {
            setNameError('Give the group a name.');
            return;
        }
        busy.current = true;
        setSaving(true);
        setSaveError('');
        const ok = await createDeviceGroup({ name: trimmed, orgId });
        busy.current = false;
        setSaving(false);
        if (ok) leave();
        else setSaveError('Couldn’t create the group. Try again.');
    };

    return (
        <AppShell>
            <div className="dv-page dets">
                <Crumb label="Devices" onClick={() => navigate('/device-management#groups')} />
                <PageHeadActions
                    title="New device group"
                    sub="Groups link several devices to an event at once."
                />
                <form onSubmit={submit} noValidate>
                    <SectionCard title="Group">
                        <Field label="Group name" error={nameError}>
                            <TextInput
                                autoFocus
                                value={name}
                                disabled={saving}
                                aria-invalid={!!nameError}
                                onChange={(e) => {
                                    setName(e.target.value);
                                    if (nameError) setNameError('');
                                }}
                            />
                        </Field>
                    </SectionCard>
                    {saveError && (
                        <p className="banner dv-note err" role="alert" style={{ marginTop: 16 }}>
                            {saveError}
                        </p>
                    )}
                    <div className="dv-actions">
                        <button type="button" className="tb-btn" disabled={saving} onClick={leave}>
                            Cancel
                        </button>
                        <button type="submit" className="tb-new" disabled={saving || !orgId}>
                            {saving ? 'Creating…' : 'Create group'}
                        </button>
                    </div>
                </form>
            </div>
        </AppShell>
    );
}
